import { testimonials } from "../../../mocks/siteData";

export default function Testimonials() {
  const featured = testimonials.find((t) => t.featured);
  const rest = testimonials.filter((t) => !t.featured);

  return (
    <section className="py-24 bg-[#FAFAFA]" id="testimonials">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
              Client Stories
            </span>
            <h2
              className="text-4xl lg:text-5xl font-semibold text-[#111111] leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              What Homeowners Say
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((s) => (
                <div key={s} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-[#C9A961] text-sm"></i>
                </div>
              ))}
            </div>
            <span className="text-sm text-[#5C5C5C]">
              <strong className="text-[#111111]">4.9/5</strong> from 500+ homeowners
            </span>
          </div>
        </div>

        {featured && (
          <div className="bg-[#111111] rounded-2xl p-10 lg:p-14 mb-8 relative overflow-hidden">
            <div
              className="absolute inset-0 opacity-5"
              style={{
                backgroundImage: "repeating-linear-gradient(45deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 50%)",
                backgroundSize: "20px 20px",
              }}
            ></div>
            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-1 flex justify-start lg:justify-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#C9A961] text-white text-xl font-semibold shrink-0">
                  {featured.initials}
                </div>
              </div>
              <div className="lg:col-span-11">
                <div className="flex mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#C9A961] text-sm"></i>
                    </div>
                  ))}
                </div>
                <blockquote
                  className="text-white text-xl lg:text-2xl leading-relaxed mb-5 font-medium italic"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  &ldquo;{featured.quote}&rdquo;
                </blockquote>
                <div>
                  <div className="text-white font-semibold text-sm">{featured.name}</div>
                  <div className="text-white/50 text-xs mt-0.5">
                    {featured.location} &middot; {featured.project}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {rest.map((t) => (
            <div
              key={t.id}
              className="break-inside-avoid bg-white rounded-xl p-6 border border-[#EBEBEB] hover:border-[#C9A961]/40 transition-colors duration-300"
            >
              <div className="flex mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A961] text-xs"></i>
                  </div>
                ))}
              </div>
              <blockquote
                className="text-[#111111] leading-relaxed mb-5 italic text-[15px]"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3 pt-4 border-t border-[#F0EDE8]">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#C9A961]/15 text-[#C9A961] text-xs font-semibold shrink-0">
                  {t.initials}
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#111111]">{t.name}</div>
                  <div className="text-xs text-[#5C5C5C]">
                    {t.location} &middot; {t.project}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
